"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var family_1 = tslib_1.__importDefault(require("../../tokens/typography/family"));
exports.default = {
    font: {
        large: {
            "font-family": family_1.default.primary,
            "font-size": "28px",
            "line-height": "24px",
            "font-weight": 500
        },
        medium: {
            "font-family": family_1.default.primary,
            "font-size": "16px",
            "line-height": "20px",
            "font-weight": 600
        },
        small: {
            "font-family": family_1.default.primary,
            "font-size": "12px",
            "line-height": "12px",
            "font-weight": 600
        }
    }
};
// Path: src/privateTokens/avatar/index.ts
//# sourceMappingURL=index.js.map